// Cover-crop an image file to an S×S PNG data URL so stored photos / logos
// stay small (the Settings pages' photo and logo uploads).
export const squareDataUrl = (file, S = 512) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => {
    const c = document.createElement("canvas"); c.width = S; c.height = S;
    const ctx = c.getContext("2d");
    const scale = Math.max(S / img.width, S / img.height);
    const w = img.width * scale, h = img.height * scale;
    ctx.drawImage(img, (S - w) / 2, (S - h) / 2, w, h);
    URL.revokeObjectURL(url);
    resolve(c.toDataURL("image/png"));
  };
  img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("Couldn't read that image.")); };
  img.src = url;
});
